import { Link, useLocation, useRouteLoaderData } from '@remix-run/react'
import type { loader as rootLoader } from '#app/root'
import { ROUTE_PATH as LOGIN_PATH } from '#app/routes/auth+/login'
import { ROUTE_PATH as DASHBOARD_PATH } from '#app/routes/dashboard+/_layout'
import { buttonVariants } from '#app/components/ui/button'
import { Logo } from '#app/components/logo'
import { cn } from '#app/utils/misc'
import { track } from '#app/utils/analytics'

export function MarketingNav() {
  const rootData = useRouteLoaderData<typeof rootLoader>('root')
  const user = rootData?.user
  const location = useLocation()
  const pricingHref = location.pathname === '/' ? '#pricing' : '/#pricing'

  return (
    <nav
      className={cn(
        'sticky top-1.5 z-50 mx-auto flex w-full max-w-screen-lg items-center justify-between rounded-lg bg-card/20 p-6 py-3 backdrop-blur transition-all duration-300 dark:bg-secondary/20',
      )}>
      <Link to="/" prefetch="intent" className="flex h-10 items-center gap-2">
        <Logo />
        <span className="text-lg font-semibold text-primary">Inbox Bridge</span>
      </Link>
      <div className="flex items-center gap-4">
        <a
          href={pricingHref}
          onClick={() => track('Homepage Pricing Viewed', { source: 'nav' })}
          className="hidden text-sm text-muted-foreground hover:text-primary sm:block">
          Pricing
        </a>
        <Link
          to={user ? DASHBOARD_PATH : LOGIN_PATH}
          onClick={() =>
            track('Homepage CTA Clicked', {
              location: 'nav_primary',
              authenticated: !!user,
            })
          }
          className={cn(buttonVariants({ size: 'sm' }), 'h-8')}>
          {user ? 'Dashboard' : 'Sign up for free'}
        </Link>
      </div>
    </nav>
  )
}
